const normalizeUrl = (url) => {
  if (url.endsWith('/')) {
    url = url.slice(0, url.length - 1)
  }
  return url
}

export default {
  SET_BACKEND_URL: (state, backendUrl) => {
    state.backendUrl = normalizeUrl(backendUrl)
  },
  SET_FRONTEND_URL: (state, frontendUrl) => {
    state.frontendUrl = normalizeUrl(frontendUrl)
  },

}